import * as React from "react";
import type { SVGProps } from "react";
const SvgEighteenPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.454 5.638h.91v.91a.909.909 0 0 0 1.818 0v-.91h.909a.91.91 0 0 0 0-1.818h-.91v-.909a.909.909 0 0 0-1.817 0v.91h-.91a.91.91 0 0 0 0 1.817Z"
    />
    <path
      fill="currentColor"
      d="M20.727 9.274a.91.91 0 0 0-.709 1.073 8.18 8.18 0 0 1-9.2 9.744A8.182 8.182 0 0 1 4.802 8.116a8.181 8.181 0 0 1 8.853-4.132.927.927 0 0 0 .363-1.818A9.82 9.82 0 0 0 12 2.002a10 10 0 0 0-9.808 11.95 9.998 9.998 0 0 0 13.635 7.287A10 10 0 0 0 21.8 10a.91.91 0 0 0-1.073-.727Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.095 15.554a4.42 4.42 0 0 1-1.28-.167 2.567 2.567 0 0 1-.896-.463 2.034 2.034 0 0 1-.532-.69 2.038 2.038 0 0 1-.177-.846c0-.361.088-.68.265-.955.184-.276.414-.49.69-.64a1.606 1.606 0 0 1-.532-.562 1.72 1.72 0 0 1-.177-.797c0-.368.095-.7.285-.995.19-.295.48-.532.867-.709.387-.177.883-.266 1.487-.266.598 0 1.09.089 1.477.266.388.17.674.404.857.7.19.295.286.626.286.994 0 .295-.06.561-.177.797-.119.23-.29.42-.512.572.288.144.521.357.699.64.177.282.266.604.266.965 0 .393-.109.755-.325 1.083-.21.328-.529.59-.956.788-.426.19-.965.285-1.615.285Zm0-1.25c.21 0 .397-.037.562-.109.17-.079.305-.184.403-.315a.808.808 0 0 0 .148-.482.797.797 0 0 0-.148-.493.958.958 0 0 0-.403-.305 1.382 1.382 0 0 0-.562-.108c-.21 0-.4.036-.571.108a.958.958 0 0 0-.404.305.797.797 0 0 0-.147.493c0 .183.049.344.147.482.099.131.233.236.404.315.17.072.361.109.571.109Zm0-3.004c.184 0 .351-.033.502-.098a.953.953 0 0 0 .355-.276.688.688 0 0 0 .128-.414.687.687 0 0 0-.128-.413.768.768 0 0 0-.345-.276 1.273 1.273 0 0 0-.512-.098c-.19 0-.36.032-.512.098a.836.836 0 0 0-.354.276.728.728 0 0 0-.119.413c0 .158.04.296.119.414.085.118.203.21.354.276.151.065.322.098.512.098Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.914 15.387a.262.262 0 0 0 .178.069h1.28a.228.228 0 0 0 .167-.07.225.225 0 0 0 .08-.176V8.809a.225.225 0 0 0-.08-.177.228.228 0 0 0-.167-.07H9.14a.403.403 0 0 0-.128.02.31.31 0 0 0-.109.05L6.64 10.384a.238.238 0 0 0-.118.168.279.279 0 0 0 .05.187l.58.758a.277.277 0 0 0 .158.108.223.223 0 0 0 .187-.049l1.35-1.034v4.688a.24.24 0 0 0 .068.177Z"
    />
  </svg>
);
export default SvgEighteenPlus;
